import type { PhotoCreditWithUser } from '../types';

export type ResolvedCredit = { id: number; fName: string; lName: string };

export const isResolvedCredit = (
  userId: PhotoCreditWithUser['userId']
): userId is ResolvedCredit => typeof userId === 'object' && userId !== null;

export const creditArtistId = (userId: PhotoCreditWithUser['userId']): string =>
  String(isResolvedCredit(userId) ? userId.id : userId);

export const creditUserName = (credit: Pick<PhotoCreditWithUser, 'userId'>): string | null =>
  isResolvedCredit(credit.userId) ? `${credit.userId.fName} ${credit.userId.lName.charAt(0)}.` : null;
